//全部产品下拉
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import { Dropdown, Menu } from "antd";
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data = "all", callback, className, props = {} }) => {
  const t = useTranslation();
  const { finance } = useStore();

  const keyLabelObj = useMemo(() => {
    return {
      SIMPLE_EARN: t("finance.allProducts"),
      SAVING: t("finance.savings"),
      STAKING: t("finance.staking")
    };
  }, []);

  return (
    <Dropdown
      overlay={
        <Menu
          selectable={true}
          selectedKeys={[data]}
          items={[
            {
              key: "SIMPLE_EARN",
              label: <a onClick={() => callback && callback("SIMPLE_EARN")}>{keyLabelObj.SIMPLE_EARN}</a>,
            },
            {
              key: "SAVING",
              label: <a onClick={() => callback && callback("SAVING")}>{keyLabelObj.SAVING}</a>,
            },
            {
              key: "STAKING",
              label: <a onClick={() => callback && callback("STAKING")}>{keyLabelObj.STAKING}</a>,
            }
          ]}
        ></Menu>
      }
      {...props}
    >
      <button className={cx("btntxt", styles.trigger, className)}>{keyLabelObj[data]}</button>
    </Dropdown>
  );
});
